import React from "react";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";

/**
 * Bottom metrics row (headline stat + uppercase caption).
 * @type {ReadonlyArray<{ stat: string, label: string }>}
 */
const IMPACT_METRICS = [
  { stat: "20hrs", label: "SAVED PER PERSON / MONTH" },
  { stat: "75%", label: "FASTER DOC TURNAROUND" },
  { stat: "90%", label: "SAY THEY HAVE FEWER REVISIONS" },
];

/**
 * Social-proof style strip: metric placeholders and mesh background.
 *
 * @returns {React.ReactElement} Impact section markup.
 */
const LandingImpactSection = () => {
  return (
    <Box
      id="impact"
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f4f6fb",
        backgroundImage: `
          radial-gradient(ellipse 80% 60% at 15% 20%, rgba(147, 197, 253, 0.45) 0%, transparent 55%),
          radial-gradient(ellipse 70% 50% at 85% 10%, rgba(196, 181, 253, 0.4) 0%, transparent 50%),
          radial-gradient(ellipse 60% 40% at 50% 90%, rgba(253, 224, 71, 0.2) 0%, transparent 45%)
        `,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 4, textAlign: { xs: "center", md: "left" } }}>
          <Typography
            variant="overline"
            sx={{
              letterSpacing: 1.2,
              fontWeight: 700,
              color: "text.secondary",
              display: "inline-block",
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              backgroundColor: "rgba(255,255,255,0.7)",
            }}
          >
            Meeting-to-document AI for B2B teams
          </Typography>
        </Box>
        <Paper
          elevation={0}
          sx={{
            py: 3,
            px: { xs: 2, md: 4 },
            borderRadius: 3,
            backgroundColor: "rgba(255,255,255,0.85)",
          }}
        >
          <Grid container alignItems="stretch">
            {IMPACT_METRICS.map((row, i) => (
              <Grid item xs={12} md={4} key={row.label}>
                <Box
                  sx={{
                    textAlign: "center",
                    py: { xs: i > 0 ? 2 : 0, md: 0 },
                    px: { md: 1 },
                    borderTop: { xs: i > 0 ? 1 : 0, md: 0 },
                    borderLeft: { md: i > 0 ? 1 : 0 },
                    borderColor: "divider",
                    borderStyle: "solid",
                  }}
                >
                  <Typography variant="h4" fontWeight={800}>
                    {row.stat}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      mt: 0.5,
                      letterSpacing: 0.8,
                      fontWeight: 600,
                      color: "text.secondary",
                      textTransform: "uppercase",
                    }}
                  >
                    {row.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
        <Typography
          variant="caption"
          component="p"
          color="text.secondary"
          sx={{ mt: 2, textAlign: "center", display: "block" }}
        >
          Illustrative benchmarks — substantiate with your own research before external use.
        </Typography>
      </Container>
    </Box>
  );
};

export default LandingImpactSection;
